// components/ApproveDialog.tsx
import React from "react";
import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Button,
  Typography,
  IconButton,
} from "@material-tailwind/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

type ApproveDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  username: string;
};

export const ApproveDialog: React.FC<ApproveDialogProps> = ({
  open,
  onClose,
  onConfirm,
  username,
}) => {
  return (
    <>
      <Dialog
        open={open}
        handler={onClose}
        size="sm"
        className="p-4 !z-[40]"
        aria-labelledby="approve-dialog-title"
        aria-describedby="approve-dialog-description"
      >
        <DialogHeader className="relative m-0 block">
          <Typography variant="h4" color="blue-gray">
            Confirm User Approval
          </Typography>
          <IconButton
            size="sm"
            variant="text"
            className="!absolute right-3.5 top-3.5"
            onClick={onClose}
          >
            <XMarkIcon className="h-4 w-4 stroke-2" />
          </IconButton>
        </DialogHeader>
        <DialogBody>
          <Typography>
            Are you sure you want to approve the account for{"  "}
            <strong>{username}</strong>? This user will gain access to the
            platform upon approval.
          </Typography>
        </DialogBody>
        <DialogFooter>
          <Button variant="text" color="gray" onClick={onClose}>
            Cancel
          </Button>
          <Button color="green" onClick={onConfirm}>
            Approve
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
};
